import { Checkbox, CheckboxState } from "react-migration/components/DeprecatedCheckbox";

import classNames from "classnames";

interface SelectOptionItemProps {
  id: string;
  name: string;
  color?: string;
  isSelected: boolean;
  onToggle: (id: string) => void;
}

export const SelectOptionItem = ({ id, name, color, isSelected, onToggle }: SelectOptionItemProps) => {
  return (
    <div
      className={classNames(
        "cursor-pointer",
        "py-2",
        "px-2",
        "mx-2",
        "rounded-sm",
        "flex",
        "flex-row",
        "gap-2",
        "items-center",
        "hover:bg-neutral-100",
        "text-sm"
      )}
      onClick={() => onToggle(id)}
      data-testid="select-filter-option-item"
    >
      <Checkbox
        data-testid="select-filter-option-item-checkbox"
        className="cursor-pointer"
        value={isSelected ? CheckboxState.CHECKED : CheckboxState.EMPTY}
        onChange={() => {
          return;
        }}
      />
      {color && <div className="w-2 h-4 rounded-sm" style={{ backgroundColor: color }} />}
      {name}
    </div>
  );
};
